import React from 'react'
import "./footer.scss";
const Footer = () => {
  return (
    <>
    <section className='headermain'>
        <div className='container'>
 <div className='innner_header'>
            <img src='\logo.svg'/>
            <h2>©2025 XEN. All rights reserved</h2>
        </div>
        </div>
       
    </section>
    </>
  )
}

export default Footer
